import dayjs from 'dayjs';

import { useFirstAvailableDateQuery } from '@/wabunka-src/features/Experience/composables/query/useFirstAvailableDateQuery';

/**
 * カレンダーに表示すべき月を返す Composable
 *
 * selectedDate が未設定の場合のみ、直近予約可能日の月にカレンダーを切り替える。
 * displayMonth を ExperienceCalendar に渡すことで、カレンダーUIの表示月が切り替わり、
 * カレンダーの onChange 経由で startDateFrom/startDateTo も自動更新される。
 *
 * @param experienceId - 体験ID（または slug）
 * @param selectedDate - 選択中の日付。null/undefined の場合は直近予約可能日の月を使用する
 */
export const useDisplayMonth = (experienceId: Ref<string>, selectedDate: Ref<dayjs.Dayjs | null | undefined>) => {
  const { firstAvailableDate } = useFirstAvailableDateQuery(experienceId);

  const displayMonth = computed(() => {
    if (selectedDate.value != null) return undefined;
    if (!firstAvailableDate.value) return undefined;
    const d = dayjs.tz(firstAvailableDate.value, 'Asia/Tokyo');
    return d.isValid() ? d : undefined;
  });

  return { displayMonth };
};
